// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4838":"76424cf14a59cefb","9287":"bc7a7aec57728422"}[chunkId] + ".css";
};